export default "{\n    \"facilityCountLabel_one\": \"{{count}} établissement\",\n    \"facilityCountLabel_other\": \"{{count}} établissements\"\n}\n"